import { useDocumentTitle } from "Components/Hooks";
import { ThankYouProps } from "SharedConstants/Schema";
import { DashboardLink, HomepageLink } from "Views/Shared/HomepageLink";
import { Heading } from "../../Components/Heading";

export function ThankYou(props: ThankYouProps) {
  useDocumentTitle(`Thank you! - ${props.TitleProps.PageTitleSuffix}`);
  return (
    <>
      <Heading {...props} title={`${props.InsuranceName} Purchased`} />
      <div>
        Your policy has been purchased! An email has been sent to you with your
        policy documents.
      </div>
      <div style={{ marginTop: "0.5em" }}>
        Thank you for allowing {props.ProducerName} and {props.WebsiteName} to
        provide you with {props.InsuranceName}.
      </div>
      <div className="has-text-weight-bold">{props.BoldedNote}</div>
      <div className="has-text-centered">
        {props.IsAuthenticated ? (
          <DashboardLink />
        ) : (
          <HomepageLink {...props.HomepageLinkProps} />
        )}
      </div>
    </>
  );
}
